import HomePage from 'src/pages/HomePage'
import MobileHomepage from 'src/mobile/pages/Homepage'
import MobileClinicList from 'src/mobile/pages/ClinicList'
import MobileClinicDetail from 'src/mobile/pages/ClinicDetail'
import MobileSignIn from 'src/mobile/pages/auth/SignIn'
import MobileSignUp from 'src/mobile/pages/auth/SignUp'
import MobileForgotPassword from 'src/mobile/pages/auth/ForgotPassword'
import OrderList from 'src/pages/order/OrderList'
import OrderInfo from 'src/components/OrderInfo'
import MobileOrderInfo from 'src/mobile/pages/order/OrderInfo'
import About from 'src/mobile/pages/About'
import Follow from 'src/mobile/pages/FollowUs'
import ContactUs from 'src/mobile/pages/ContactUs'
import Questions from 'src/pages/Questions'
import MobileQuestions from 'src/mobile/pages/Questions'
import MobilePromotion from 'src/mobile/pages/Promotion'
import MobileAddOrder from 'src/mobile/pages/order/AddOrder'
import Agreement from 'src/pages/Agreement'
import MobileAgreement from 'src/mobile/pages/Agreement'
import ProductList from 'src/mobile/pages/ProductList'
import ProductListPC from 'src/pages/ProductList'
import Promotion from 'src/pages/Promotion'
import PromotionLanding from 'src/pages/PromotionLanding'
import MobileProfile from 'src/mobile/pages/Profile'
import PcPageHolder from 'src/mobile/pages/PcPageHolder'
import ProductInfo from 'src/pages/ProductInfo'
import ProductInfoNPC from 'src/pages/ProductInfoNPC'
import ProductHealthCheck from 'src/pages/ProductHealthCheck'
import PreDetail from 'src/mobile/components/Order/Detail'

const baseRoutes = [
  {
    path: '/:lang(en|zh-HK|zh-CN)/',
    component: HomePage,
    mobileComponent: MobileHomepage,
    header: null,
    bgColor: 'background.default',
    footer: true,
    footerBottom: true,
  },
  {
    path: '/:lang(en|zh-HK|zh-CN)/clinic/:id',
    component: MobileClinicDetail,
    mobileComponent: MobileClinicDetail,
    header: {
      title: 'glossary.clinic_details',
      goBack: true,
      titleGoHome: true,
    },
    bgColor: 'background.default',
    footerBottom: true,
  },
  {
    path: '/:lang(en|zh-HK|zh-CN)/clinic',
    component: MobileClinicList,
    mobileComponent: MobileClinicList,
    header: {
      title: 'glossary.clinic_list',
      goBack: true,
    },
    bgColor: 'background.default',
    footerBottom: true,
  },

  {
    path: '/:lang(en|zh-HK|zh-CN)/faq',
    component: Questions,
    mobileComponent: MobileQuestions,
    header: {
      // title: 'glossary.faq',
      goBack: true,
    },
    footer: true,
    footerBottom: true,
  },
  {
    path: '/:lang(en|zh-HK|zh-CN)/promotion',
    component: Promotion,
    mobileComponent: MobilePromotion,
    header: {
      // title: 'promotion',
      goBack: true,
    },
    footer: true,
    footerBottom: true,
  },
  {
    path: '/:lang(en|zh-HK|zh-CN)/ProductList',
    component: ProductListPC,
    mobileComponent: ProductList,
    header: {
      // title: 'promotion',
      goBack: true,
    },
    footer: true,
    footerBottom: true,
  },
  {
    path: '/:lang(en|zh-HK|zh-CN)/preOrder',
    component: PreDetail,
    mobileComponent: PreDetail,
    exact: true,
    header: {
      title: 'glossary.confirm_your_booking_details',
      goBack: true,
    },
    withFixedButton: true,
    bgColor: 'background.default',
    footerBottom: true,
  },
  {
    path: '/:lang(en|zh-HK|zh-CN)/add-order',
    component: MobileAddOrder,
    mobileComponent: MobileAddOrder,
    exact: true,
    header: {
      title: 'glossary.confirm_your_booking_details',
      goBack: true,
    },
    withFixedButton: true,
    bgColor: 'background.default',
    // footer: true,
    footerBottom: true,
  },
  {
    path: '/:lang(en|zh-HK|zh-CN)/agreement/:id',
    component: Agreement,
    mobileComponent: MobileAgreement,
    header: {
      title: 'glossary.user_service_agreement',
      goBack: true,
    },
    footer: true,
    footerBottom: true,
  },
  {
    path: '/:lang(en|zh-HK|zh-CN)/promotions_NEW330',
    component: PromotionLanding,
    mobileComponent: PromotionLanding,
    header: {
      title: 'glossary.user_service_agreement',
      goBack: true,
    },
    footer: true,
    footerBottom: true,
  },
  {
    path: '/:lang(en|zh-HK|zh-CN)/about',
    component: PcPageHolder,
    mobileComponent: About,
    header: {
      title: 'glossary.about_take2',
      goBack: true,
    },
    bgColor: 'background.default',
    // footer: true,
    // footerBottom: true,
  },
  {
    path: '/:lang(en|zh-HK|zh-CN)/follow-us',
    component: PcPageHolder,
    mobileComponent: Follow,
    header: {
      title: 'glossary.follow_us',
      goBack: true,
    },
    bgColor: 'background.default',
    footer: true,
    footerBottom: true,
  },
  {
    path: '/:lang(en|zh-HK|zh-CN)/contact-us',
    component: PcPageHolder,
    mobileComponent: ContactUs,
    header: {
      title: 'glossary.contact_us',
      goBack: true,
    },
    bgColor: 'background.default',
    footer: true,
    footerBottom: true,
  },
  {
    path: '/:lang(en|zh-HK|zh-CN)/product-cancer-screening',
    component: ProductInfo,
    mobileComponent: ProductInfo,
    header: {
      title: 'glossary.product_info',
      goBack: true,
    },
    bgColor: 'background.default',
    // footer: true,
    footerBottom: true,
  },
  {
    path: '/:lang(en|zh-HK|zh-CN)/product-prophecy',
    component: ProductInfoNPC,
    mobileComponent: ProductInfoNPC,
    header: {
      title: 'glossary.product_info',
      goBack: true,
    },
    bgColor: 'background.default',
    // footer: true,
    footerBottom: true,
  },
  {
    path: '/:lang(en|zh-HK|zh-CN)/product-standard-health-check-package',
    component: ProductHealthCheck,
    mobileComponent: ProductHealthCheck,
    header: {
      title: 'glossary.product_info',
      goBack: true,
    },
    bgColor: 'background.default',
    // footer: true,
    footerBottom: true,
  },
  {
    path: '/:lang(en|zh-HK|zh-CN)/product-male-health-check-package',
    component: ProductHealthCheck,
    mobileComponent: ProductHealthCheck,
    header: {
      title: 'glossary.product_info',
      goBack: true,
    },
    bgColor: 'background.default',
    // footer: true,
    footerBottom: true,
  },
  {
    path: '/:lang(en|zh-HK|zh-CN)/product-female-health-check-package',
    component: ProductHealthCheck,
    mobileComponent: ProductHealthCheck,
    header: {
      title: 'glossary.product_info',
      goBack: true,
    },
    bgColor: 'background.default',
    // footer: true,
    footerBottom: true,
  },
]

const authRoutes = [
  {
    path: '/:lang(en|zh-HK|zh-CN)/signin',
    component: MobileSignIn,
    mobileComponent: MobileSignIn,
  },
  {
    path: '/:lang(en|zh-HK|zh-CN)/signup',
    component: MobileSignUp,
    mobileComponent: MobileSignUp,
  },
  {
    path: '/:lang(en|zh-HK|zh-CN)/forgot-password',
    component: MobileForgotPassword,
    mobileComponent: MobileForgotPassword,
    header: {
      title: 'glossary.appointment_order',
      goBack: true,
    },
  },
]

const userRoutes = [
  {
    // title: 'glossary.appointment_order',
    path: '/:lang(en|zh-HK|zh-CN)/profile/order',
    component: OrderList,
    mobileComponent: MobileProfile,
    header: {
      title: 'glossary.appointment_order',
      goBack: true,
    },
    bgColor: 'background.default',
    footer: true,
    footerBottom: true,
    sideBar: true,
  },
  {
    title: 'glossary.appointment_detail',
    path: '/:lang(en|zh-HK|zh-CN)/profile/order/:orderNumber',
    component: OrderInfo,
    mobileComponent: MobileOrderInfo,
    header: {
      title: 'glossary.appointment_summary',
      goBack: true,
    },
    withFixedButton: true,
    bgColor: 'background.default',
    footer: true,
    footerBottom: true,
  },
  {
    // title: '12',
    path: '/:lang(en|zh-HK|zh-CN)/profile/account',
    component: MobileProfile,
    mobileComponent: MobileProfile,
    header: {
      title: 'glossary.enter_personal_info',
      goBack: true,
    },
    withFixedButton: true,
    bgColor: 'background.default',
    footer: true,
    footerBottom: true,
    sideBar: true,
  },
  {
    title: 'glossary.account_setting',
    path: '/:lang(en|zh-HK|zh-CN)/profile',
    header: {
      title: 'glossary.enter_personal_info',
      goBack: true,
    },
    component: MobileProfile,
    mobileComponent: MobileProfile,
    footer: true,
    footerBottom: true,
    sideBar: true,
  },
]

export { baseRoutes, authRoutes, userRoutes }
